<template>
  <div class="">
    <div class="item">
      <img
        class="item-title"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/4813c235881b7d89dda5e7b4fdc11ae2.png"
        alt=""
      />
      <div @click="bindClick">
        <img
          class="item-image"
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/28d3373c5d4303092df96becc7832149.png"
          alt=""
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {}
  },
  created() {},
  methods: {
    bindClick() {
      this.$betterwe.vipHomePage()
    }
  }
}
</script>
<style lang="scss" scoped>
.item {
  position: relative;
  border-style: solid;
  border-left-width: 0;
  border-right-width: 0;
  border-top-width: 20px;
  border-bottom-width: 20px;
  border-image-source: url('https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/33c32071d346077825362b29fdf00ae6.png');
  border-image-slice: 60 0 60 0 fill;
  border-image-width: 20px 0 20px 10;
  padding: 40px 14px 10px;
  margin-bottom: 60px;

  .item-title {
    position: absolute;
    left: 50%;
    top: -20px;
    width: 262px;
    height: 94px;
    transform: translate(-50%, -57.4%);
  }

  .item-image {
    width: 100%;
  }
}
</style>
